import PropTypes from 'prop-types';
import { memo } from 'react';
import { useSelector } from 'react-redux';
import CustomInventorySearchBar from '../../Header/Searchbar/CustomInventory';
import CustomInventoryList from './CustomInventoryList';

const CustomInventoryInformation = ({
  tripId, onMouseEnter, onMouseLeave, isExpanded, doHaveBorderAround,
}) => {
  const { travelAgency = {} } = useSelector((store) => store.user);
  return (
    <div className="mx-5 my-5">
      <CustomInventorySearchBar
        tripId={tripId}
        tabContent={travelAgency && travelAgency.searchbarTab}
      />
      <CustomInventoryList
        tripId={tripId}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
        isExpanded={isExpanded}
        doHaveBorderAround={doHaveBorderAround}
      />
    </div>
  );
};

CustomInventoryInformation.propTypes = {
  tripId: PropTypes.string.isRequired,
  doHaveBorderAround: PropTypes.bool,
  onMouseEnter: PropTypes.func,
  onMouseLeave: PropTypes.func,
  isExpanded: PropTypes.shape({
    value: PropTypes.bool,
  }),
};

CustomInventoryInformation.defaultProps = {
  doHaveBorderAround: true,
  onMouseEnter: undefined,
  onMouseLeave: undefined,
  isExpanded: undefined,
};

export default memo(CustomInventoryInformation);
